<template>
  <v-row>
    <v-col cols="12">
      <v-card class="v-card--no-style">
        <v-list v-if="benefitsUsage.list.length" three-line style="background:none;">
          <history-item v-for="(event, index) in benefitsUsage.list" :key="index" :event="event" />
        </v-list>

        <v-layout v-else>
          <v-flex px-4>Twoja historia jest pusta, zacznij używać karty u naszych partnerów.</v-flex>
        </v-layout>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex';

import HistoryItem from './HistoryItem';

/**
 * @vuese
 * Historia wykorzystanych usług
 * @group History
 */
export default {
  components: { HistoryItem },
  props: {
    // czy pokazywać nagłówek nad listą
    header: { type: Boolean, default: true },
    // ikona do wyświetlenia nad listą
    icon: { type: String, default: 'mdi-history' },
    // tytuł listy
    title: { type: String, required: true },
    // czy pokazywać slot więcej
    showMore: { type: Boolean, default: false },
    // ikona 'więcej'
    moreIcon: { type: String, default: 'history' },
    // obiekt route do przekazania dla przycisku więcej
    moreTarget: {
      type: Object,
      default: () => {
        return {
          name: 'history'
        };
      }
    }
  },

  computed: mapState({
    benefitsUsage: state => state.benefitsUsage
  })
};
</script>

<style>
.history {
  max-width: 600px;
}
</style>
